import { memo, useCallback, useState } from "react"
import api from "../../utils/axios"
import { CircularProgress, Grid2, IconButton, TextField, Typography } from "@mui/material"
import { ITranslation } from "sierra"
import { Check, Close } from "@mui/icons-material"
import { useAuth } from "../../hooks/useAuth"

const TranslationRow = memo(({ translation }: { translation: ITranslation }) => {
    const [tempTranslation, setTempTranslation] = useState<ITranslation>(translation)
    const [afterTranslation, setAfterTranslation] = useState<ITranslation>(translation)
    const [apiCall, setApiCall] = useState<boolean>(false)
    const {user} = useAuth()

    const handleUpdateTranslation = useCallback(() => {
        setApiCall(true)
        api.patch(`/translations/${translation.id}`, {
            translation: {
                en: tempTranslation.en,
                ar: tempTranslation.ar,
                zh: tempTranslation.zh
            }
        }, { meta: { showSnackbar: true } }).then(() => {
            setApiCall(false)
            setAfterTranslation(tempTranslation)
        }).catch(err => {
            setApiCall(false)
            console.log(err)
        })

    }
        , [tempTranslation, translation])

    return (
        <Grid2 container display={'flex'} alignItems={'center'}>
            <Grid2 size={"auto"} minWidth={200} display={{ xs: 'none', sm: 'flex' }}>
                <Typography>{user && user.role !== 'customer' && `(#${tempTranslation.id})`} {tempTranslation.translation_type}:</Typography>
            </Grid2>
            {(["en", "ar", "zh"] as const).map((k) => (
                <Grid2 size={"grow"} key={k}>
                    <TextField
                        fullWidth
                        size="small"
                        value={tempTranslation[k] || ""}
                        sx={{ backgroundColor: 'rgba(255, 255, 255, 0.3)' }}
                        // multiline LAGS EVERYTHING
                        onChange={(e) =>
                            setTempTranslation((prev) =>
                                prev.id === tempTranslation.id
                                    ? { ...prev, [k]: e.target.value }
                                    : prev
                            )
                        }
                    />
                </Grid2>
            ))}
            <Grid2 container justifyContent={'center'} display={'space-around'}>
                {JSON.stringify(tempTranslation) !== JSON.stringify(afterTranslation) &&
                    <>
                        <Grid2>
                            {apiCall ? <CircularProgress /> :
                                <IconButton color='success' onClick={handleUpdateTranslation}>
                                    <Check />
                                </IconButton>
                            }
                        </Grid2>
                        <Grid2>
                            <IconButton color='error' onClick={() => setTempTranslation(afterTranslation)}>
                                <Close />
                            </IconButton>
                        </Grid2>
                    </>
                }
            </Grid2>
        </Grid2>
    )
})

export default TranslationRow